import React from 'react';
import { FooterNavigation } from 'layout/DataMenu';

const ContactInfo = ({ headline = 'Find Us' }) => {
  return (
    <div className="w-full max-w-xl mx-auto xl:mx-0">
      <h1 className="font-black text-3xl md:text-4xl text-kin-text tracking-tight mb-6 text-center xl:text-left">
        {headline}
      </h1>

      {/* Card Informasi Utama */}
      <div className="rounded-2xl bg-white/90 backdrop-blur-md p-6 md:p-8 shadow-xl shadow-slate-100/70 border border-slate-100">
        {/* Alamat */}
        <div className="mb-6">
          <h2 className="font-bold text-lg text-slate-800 mb-2 flex items-center gap-2">
            📍 Location
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed font-medium pl-6">
            SCBD PARK, Lot 7A, 02, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12190
          </p>
        </div>

        {/* Jam Operasional */}
        <div className="mb-8 pl-6">
          <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 flex items-center gap-4">
            <span className="text-xl">🕒</span>
            <div>
              <div className="text-sm font-bold text-slate-800">Everyday</div>
              <div className="text-sm font-semibold text-slate-500">9:00 am - 8:00 pm</div>
            </div>
          </div>
        </div>

        {/* Kontak & Social Media */}
        <div className="pt-6 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h3 className="font-bold text-xs uppercase tracking-wider text-slate-400 mb-2 sm:text-left">
              Follow Us
            </h3>
            <div className="flex gap-3 justify-start sm:justify-end">
              {FooterNavigation?.social?.map((item, idx) => (
                <a
                  key={idx}
                  href={item.href}
                  aria-label={item.label}
                  className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 hover:bg-slate-800 hover:text-white transition-all duration-300">
                  {item.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
